import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/home',
      name: 'home',
      meta: {
        title: '',
      },
      component:resolve => require(['../views/home.vue'], resolve),
      // component: require('../views/houses.vue'),
    },
    {
      path: '/product',
      name: 'product',
      meta: {
        title: '',
      },
      component:resolve => require(['../views/product.vue'], resolve),
      // component: require('../views/houses.vue'),
    },
    {
      path: '/service',
      name: 'service',
      meta: {
        title: '',
      },
      component:resolve => require(['../views/service.vue'], resolve),
      // component: require('../views/houses.vue'),
    },
    {
      path: '/about',
      name: 'about',
      meta: {
        title: '',
      },
      component:resolve => require(['../views/about.vue'], resolve),
      // component: require('../views/houses.vue'),
    },
    {
      path: '/about/news/:newsId',
      name: 'news',
      meta: {
        title: '',
      },
      component: resolve => require(['../views/news.vue'], resolve),
      // component: require('../views/houses.vue'),
    },
    {
      path: '/download',
      name: 'download',
      meta: {
        title: '',
      },
      component:resolve => require(['../views/download.vue'], resolve),
      // component: require('../views/houses.vue'),
    },
    { path: '*', redirect: '/home' },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js